import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "@/plugins/vuetify";
import router from "./router";
import store from "./store";

// Note: Ensure your 'service' wrapper is Vue 3/Axios compatible
import service from "@/services/service.js";

// 1. Import the explicit format method from date-fns package
import { format as formatLogDate } from "date-fns"; 

// 2. Initialize the Vue 3 Application Instance
const app = createApp(App);

// 3. Rewrite your global formatting properties to use date-fns directly
app.config.globalProperties.formatDateTime = function (value) {
  if (value instanceof Date) {
    return formatLogDate(value, "yyyy/MM/dd HH:mm"); // 👈 Replaced this.$date
  } else if (value) {
    return formatLogDate(new Date(value), "yyyy/MM/dd HH:mm");
  }
  return "";
};

app.config.globalProperties.formatDate = function (value) {
  if (value instanceof Date) {
    return formatLogDate(value, "yyyy-MM-dd"); // 👈 Replaced this.$date
  } else if (value) {
    return formatLogDate(new Date(value), "yyyy-MM-dd");
  }
  return "";
};

app.config.globalProperties.sortVersion = function (x, y) {
  if (!!x && !!y) {
    var xArr = x.split(".");
    var yArr = y.split(".");
    for (var i = 0; i < xArr.length; i++) {
      var result = this.sortNumber(parseInt(xArr[i]), parseInt(yArr[i]));
      if (result != 0) {
        return result;
      }
    }
  }
  return 0;
};

app.config.globalProperties.sortNumber = function (x, y) {
  return x < y ? -1 : x > y ? 1 : 0;
};

app.config.globalProperties.getCurrency = function () {
  if (
    window.location.origin.toLowerCase() ===
    "https://monadmanagementau.monadticketing.com"
  ) {
    return "AUD";
  } else {
    return "GBP";
  }
};

// 3. Register Plugins
app.use(router);
app.use(store);
app.use(vuetify);

// Note on 'date-fns': The original file did Vue.use(DateFns), but date-fns is a 
// standard JS library, not a Vue plugin. If you used a specific wrapper like 'vue-date-fns' 
// that sets up 'this.$date', make sure that wrapper supports Vue 3. Otherwise, you may 
// need to manually bind a date helper to app.config.globalProperties.$date

// 4. Initialisation Logic (Moved from Vue 2's created hook)
const sessionString = localStorage.getItem("session");
if (sessionString) {
  const session = JSON.parse(sessionString);
  store.commit("SET_SESSION", session); // Uses your Vuex store directly
  service.setAuthHeader(session);
  service.getCurrentVersions().then(response => {
    store.dispatch("setCurrentVersions", response.data[0]);
  });
}

service.setErrorHandler(function errorHandler(error, currentStore) {
  if (error.response.status === 401) {
    currentStore.dispatch("addMessage", {
      message: error.response
    });
  } else {
    currentStore.dispatch("addMessage", {
      message: error.response
    });
    console.log(error.response);
    throw error;
  }
}, store);

// 5. Mount the application
app.mount("#app");
